var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6426 0.466797C7.80233 0.466797 5.22533 1.25129 3.31508 2.57428C1.40558 3.89502 0.142578 5.80675 0.142578 7.96673C0.142578 8.16564 0.221596 8.35641 0.362248 8.49706C0.5029 8.63771 0.693666 8.71673 0.892578 8.71673C1.09149 8.71673 1.28226 8.63771 1.42291 8.49706C1.56356 8.35641 1.64258 8.16564 1.64258 7.96673C1.64258 6.388 2.55458 4.92476 4.17008 3.80727C5.78333 2.68903 8.08058 1.96678 10.6426 1.96678C13.2038 1.96678 15.5026 2.68903 17.1173 3.80727C18.7321 4.92476 19.6426 6.388 19.6426 7.96673C19.6426 8.16564 19.7216 8.35641 19.8622 8.49706C20.0029 8.63771 20.1937 8.71673 20.3926 8.71673C20.5915 8.71673 20.7823 8.63771 20.9229 8.49706C21.0636 8.35641 21.1426 8.16564 21.1426 7.96673C21.1426 5.80675 19.8811 3.89577 17.9708 2.57428C16.0613 1.25054 13.4828 0.466797 10.6426 0.466797Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6426 4.9668C8.58008 4.9668 6.89258 6.65428 6.89258 8.71676C6.89258 10.7792 8.58008 12.4667 10.6426 12.4667C12.7051 12.4667 14.3926 10.7792 14.3926 8.71676C14.3926 6.65428 12.7051 4.9668 10.6426 4.9668ZM10.6426 6.46678C11.8943 6.46678 12.8926 7.46578 12.8926 8.71676C12.8926 9.96925 11.8943 10.9667 10.6426 10.9667C9.39083 10.9667 8.39258 9.96925 8.39258 8.71676C8.39258 7.46578 9.39083 6.46678 10.6426 6.46678Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f98a4c4c740eb9d8b5bab48f54fe4d6a.svg";
export { ForwardRef as ReactComponent };